module.exports = __webpack_public_path__ + "img/ghana.357fc2f.webp";